// @flow

import * as React from 'react';
import { observable } from 'mobx';
import { observer, action } from 'mobx-react';
import { Row, Col } from 'reactstrap';
import OverviewHeader from '../../Components/Layout/OverviewHeader/index';
import Analyse from '../../Model/Analyse';
import SearchBar from '../../Components/Layout/SearchBar/index';
import PageResult from '../../Model/PageResult';
import Pager from '../../Components/Pager';
import AnalyseTable from './AnalyseTable';
import LoadingOverlay from '../../Components/LoadingOverlay';
import Settings from '../../Model/Settings';
import SettingsHtml from '../../Components/SettingsHtml';

type Props = {
  router: any,
};

@observer
export default class AnalysisIndexScreen extends React.Component<Props, void> {
  @observable
  query: string = '';
  @observable
  page: number = 1;
  @observable
  result: PageResult<Analyse> = new PageResult();
  @observable
  loading: boolean = false;
  @observable
  settings: Settings = new Settings();
  @observable
  neverLoaded: boolean = true;
  debounce: any;

  componentDidMount() {
    this.loadSettings();
    if (this.props.location.state) {
      this.query = this.props.location.state.query;
      this.load(this.props.location.state.query, this.props.location.state.page);
    }
  }

  async loadSettings() {
    this.settings = await Settings.get();
  }

  async load(query: ?string, page?: number = 0) {
    this.loading = true;
    try {
      this.neverLoaded = false;
      this.result = await Analyse.list({ query, page, 'tags[]': query });
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  }

  handleCreate = () => {
    this.props.router.push(`/analysis/new`);
  };

  handleSearch = (query: string) => {
    this.query = query;
    this.page = 0;
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      this.load(this.query, this.page);
    }, 300);
  };

  handlePage = (page: number) => {
    if (this.page !== page) {
      this.page = page;
      this.load(this.query, this.page);
    }
  };

  handleClick = (analyse: Analyse) => {
    this.props.router.push({
      pathname: `/analysis/${analyse.id}`,
      state: {
        query: this.query,
        page: this.page,
      }
    });
  };

  render() {
    const {
      settings,
      result,
      loading,
      result: { data: analysis },
    } = this;

    return (
      <React.Fragment>
        <OverviewHeader
          header={'Analysen'}
          action={'Analyse erstellen'}
          onPress={this.handleCreate}
        />
        <SearchBar onChange={this.handleSearch} value={this.query} />
        {!this.neverLoaded ? (
          <React.Fragment>
            <Row>
              <Col>
                <Pager page={result} onPage={this.handlePage} />
              </Col>
            </Row>
            <Row>
              <Col>
                <AnalyseTable analysis={analysis} onClick={this.handleClick} />
                <LoadingOverlay show={loading} />
              </Col>
            </Row>
            <Row>
              <Col>
                <Pager page={result} onPage={this.handlePage} />
              </Col>
            </Row>
          </React.Fragment>
        ) : null}
        <Row style={{ paddingTop: 32 }}>
          <Col>
            <SettingsHtml settings={settings} settingsKey={'homepage_bottom_html'} />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Views/Analysis/index.js